var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.666656C4.4 0.666656 0.666664 4.39999 0.666664 8.99999C0.666664 13.6 4.4 17.3333 9 17.3333C13.6 17.3333 17.3333 13.6 17.3333 8.99999C17.3333 4.39999 13.6 0.666656 9 0.666656ZM9 15.6667C5.325 15.6667 2.33333 12.675 2.33333 8.99999C2.33333 5.32499 5.325 2.33332 9 2.33332C12.675 2.33332 15.6667 5.32499 15.6667 8.99999C15.6667 12.675 12.675 15.6667 9 15.6667ZM12.825 5.31666L7.33333 10.8083L5.175 8.65832L4 9.83332L7.33333 13.1667L14 6.49999L12.825 5.31666Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgCheckCircle);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/check-circle.75b00e5b51b9f0277e50895cd7d3c966.svg";